import React from "react";
import CollectionName from "../../molecules/collection-name";
import StoryCard12 from "../../molecules/story-card12";
import { filterStory } from "../../helper/api";

import "./opinion-stories.m.css";

const OpinionStories = ({ collection }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  if (!stories.length) {
    return null;
  }
  return (
    <>
      <CollectionName collection={collection} />
      <div styleName="wrapper">
        {stories?.splice(0, 4).map((item, index) => (
          <StoryCard12 story={item} key={index} />
        ))}
      </div>
    </>
  );
};

export default OpinionStories;
